"use client"

import Navbar from "@/Components/DoctorsDashboard/AdminDashboard/Navbar";
import Sidebar from "@/Components/DoctorsDashboard/AdminDashboard/Sidebar";
import Link from "next/link";
import SearchFilterMedication from "@/Components/DoctorsDashboard/SearchModule/SearchFilterMedication";
import BackButton from "@/Components/Common/Buttons/BackButton";
import { useSelector } from "react-redux";
import { useSearchParams } from "next/navigation";

const SearchQueryMain = () => {
  const users = useSelector((state) => state?.userData?.userData?.user);
  const searchParams = useSearchParams();
  const returnTo = searchParams.get("returnTo");
  const safeReturnTo =
    returnTo?.startsWith("/") && !returnTo.startsWith("//")
      ? returnTo
      : null;
  const defaultBackLink = users && users.type != "reps" ? "/search" : "/";
  return (
    <>
    
      <div className="flex flex-col w-full p-5 h-full">
        <BackButton link={safeReturnTo || defaultBackLink} />
        <SearchFilterMedication />
      </div>
    </>
  );
};

export default SearchQueryMain;
